<div *ngIf='(vm$ | async) as vm'>
    <app-page-header [vm]="vm" title='Live GPS' [canGoBack]="true" [canRefresh]="true" (refreshClick)="refreshPage()"
        [notify]="notifyObj"></app-page-header>

    <!-- body -->
    <div class="row center">

        <!-- stat panel -->
        <div class="col-md-12 pt-3" *ngIf="vm.statPanelVm as svm">
            <mdb-card narrower="true" cascade="true">
                <app-card-header [title]="svm.data.title" [headingSize]="3"></app-card-header>
                <mdb-card-body cascade="true">
                    <div class="row">
                        <div class="col-md-3 pb-3" *ngFor="let s of svm.data.stats">
                            <h5>
                                <strong>{{s.statName}}:</strong>
                                <small class="text-muted pl-1">{{s.intValue}}</small>
                            </h5>
                        </div>
                    </div>
                </mdb-card-body>
            </mdb-card>
        </div>
    </div>

    <div class="row">

        <div class="col-md-12 pt-3" *ngIf="!vm.workingText">

            <!-- mobile -->
            <div class="d-block d-md-none">
                <div class="row">
                    <div class="col-md-6 pt-3" *ngIf="vm.corpGPSPanellVm as cmv">
                        <app-data-table-card [vm]="cmv" [includeAction]="false" (actionFunc)="putTicket($event)"
                            (actionMethod)="doAction($event)" [keyColumn]="0" [showHeader]="true">
                        </app-data-table-card>
                    </div>
                    <div class="col-md-6 pt-3" *ngIf="vm.farmoutGPSPanelVm as nmv">
                        <app-data-table-card [vm]="nmv" [includeAction]="false" (actionFunc)="putTicket($event)"
                            (actionMethod)="doAction($event)" [keyColumn]="0" [showHeader]="true">
                        </app-data-table-card>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 pt-3" *ngIf="vm.drVehAssignmentDupPanelVm as dvad">
                        <app-data-table-card [vm]="dvad" [includeAction]="false" (actionFunc)="putTicket($event)"
                            (actionMethod)="doAction($event)" [keyColumn]="0" [showHeader]="true">
                        </app-data-table-card>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 pt-3" *ngIf="vm.wrongVehiclesPanelVm as wvpvm">
                        <app-data-table-card [vm]="wvpvm" [includeAction]="false" (actionFunc)="putTicket($event)"
                            (actionMethod)="doAction($event)" [keyColumn]="0" [showHeader]="true">
                        </app-data-table-card>
                    </div>
                </div>
            </div>

            <!-- desktop -->
            <div class="d-none d-md-block">
                <mdb-tabset #staticTabs [buttonClass]="'md-tabs blue-gradient'" [contentClass]="'card'">
                    <mdb-tab heading="Aff Issues">
                        <div *ngIf="vm.farmoutGPSPanelVm as dtvm">
                            <app-data-table-card [vm]="dtvm" [includeAction]="false" (actionFunc)="putTicket($event)"
                                (actionMethod)="doAction($event)" [keyColumn]="0" [showHeader]="false">
                            </app-data-table-card>
                        </div>
                    </mdb-tab>
                    <mdb-tab heading="Corp Issues">
                        <div *ngIf="vm.corpGPSPanellVm as dtvm">
                            <app-data-table-card [vm]="dtvm" [includeAction]="false" (actionFunc)="putTicket($event)"
                                (actionMethod)="doAction($event)" [keyColumn]="0" [showHeader]="false">
                            </app-data-table-card>
                        </div>
                    </mdb-tab>
                    <mdb-tab heading="Dupe Vehicles">
                        <div *ngIf="vm.drVehAssignmentDupPanelVm as dtvm">
                            <app-data-table-card [vm]="dtvm" [includeAction]="false" (actionFunc)="putTicket($event)"
                                (actionMethod)="doAction($event)" [keyColumn]="0" [showHeader]="false">
                            </app-data-table-card>
                        </div>
                    </mdb-tab>
                    <mdb-tab heading="Wrong Vehicles">
                        <div *ngIf="vm.wrongVehiclesPanelVm as dtvm">
                            <app-data-table-card [vm]="dtvm" [includeAction]="false" (actionFunc)="putTicket($event)"
                                (actionMethod)="doAction($event)" [keyColumn]="0" [showHeader]="false">
                            </app-data-table-card>
                        </div>
                    </mdb-tab>

                    <mdb-tab heading="Live Map" *ngIf="vm.mapVm as mvm">
                        <div *ngIf="mvm.errorText" class="alert alert-warning" role="alert">{{mvm.errorText}}</div>

                        <agm-map *ngIf="mvm.centerPoint" style="height: 1280px"
                            [latitude]="39.099724"
                            [longitude]="-94.578331" [zoom]="5"
                        >
                            <agm-marker *ngFor="let marker of mvm.markers" [latitude]="marker.latitude"
                                [longitude]="marker.longitude" [title]="marker.title" [agmFitBounds]="true">
                                <agm-info-window *ngIf="marker.details">
                                    <div *ngFor="let d of marker.details" class="pb-3">
                                        <h5 class="mb-0">{{d.title}}</h5>
                                        <hr class="mt-0 mb-2" />
                                        <div *ngFor="let r of d.rows">
                                            <b>{{r.title}}:</b>
                                            <span class="pl-1">{{r.value}}</span>
                                        </div>
                                    </div>
                                </agm-info-window>
                            </agm-marker>
                        </agm-map>
                    </mdb-tab>
                </mdb-tabset>
            </div>
        </div>
    </div>


</div>